/*open-close mobile menu*/
(function () {
    $(document).ready(function () {
        const sCatalogMenuMobile = $('#s-menu-catalog-mobile');
        const body = $('body');
        const menuMobile = $('#h-menu-mobile');
        const btnHamburger = $('#h-hamburger');

        function open_sCatalogMenuMobile(btn) {

            if (body.hasClass('s-menu-catalog-mobile-open')) {
                sCatalogMenuMobile.removeClass('active');
                btn.removeClass('s-menu-catalog-mobile-open');
                body.removeClass('s-menu-catalog-mobile-open');
                body.removeClass('overflowY_hidden');
            } else {

                /*if mobile burger-menu was opened before - close it*/
                if (body.hasClass('menu-mobile-open')) {
                    menuMobile.removeClass('active');
                    btnHamburger.removeClass('menu-mobile-open');
                    body.removeClass('menu-mobile-open');
                    body.removeClass('overflowY_hidden');
                }

                /*open mobile catalog menu*/
                body.addClass('s-menu-catalog-mobile-open');
                body.addClass('overflowY_hidden');
                btn.addClass('s-menu-catalog-mobile-open');
                sCatalogMenuMobile.addClass('active');
            }
        }

        /*$('#s-menu-catalog-mobile-btn-header').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            open_sCatalogMenuMobile($this);
        });

        $('#s-menu-catalog-mobile-btn-bottom').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);

            open_sCatalogMenuMobile($this);
        });*/
    });
})();
